import { render, staticRenderFns } from "./PaymentLogBody.vue?vue&type=template&id=a5d3aa60&"
import script from "./PaymentLogBody.vue?vue&type=script&lang=ts&"
export * from "./PaymentLogBody.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports